<template>
  <span>{{ text }}</span>
</template>

<script>
import { PRIORITY_SLUGS } from '@/libs/priorities'

export default {
  name: 'PriorityText',
  props: {
    priorityId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    text() {
      const slug = PRIORITY_SLUGS[this.priorityId]
      return slug ? this.$t(`priorities.${slug}`) : '-'
    },
  },
}
</script>
